import type { JSX } from 'react';
import { ServiceOrganizationRoleDistributions } from '@frontend/components/pages/organizations/serviceSettings/serviceOrganizationSetting/serviceOrganizationRoleDistributions/ServiceOrganizationRoleDistributions';
import { ServiceOrganizationSettingZorgmail } from '@frontend/components/pages/organizations/serviceSettings/serviceOrganizationSetting/serviceOrganizationSettingZorgmail/ServiceOrganizationSettingZorgmail';

// For now the `BariPre` and `BariPost` are the same so there is no need for separate components
export function BariatricsHospitalSettings(): JSX.Element {
    return (
        <>
            <ServiceOrganizationRoleDistributions />
            <ServiceOrganizationSettingZorgmail />
        </>
    );
}
